module.exports = __webpack_public_path__ + "mainassets/img/chevron-left.82436d11.svg";